<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="mat-card-info" (click)="locationDisplayToggle=!locationDisplayToggle"><a href="javascript:">User Location</a></mat-card-title>
    </mat-card-header>
    <mat-card-content >
      <div class="row" *ngIf="locationDisplayToggle">
          <table class="table" id="user-locations-table">
            <tbody>
              <tr>
                <th>Location ID</th>
                <th>Property Name</th>
                <th>Role</th>
                <!-- <th>Actions</th> -->
              </tr>
              <tr *ngFor="let location of locations">
                <td>{{ location?.id }}</td>
                <td><a [routerLink]="'/location/'+ location.id">{{ location?.label }}</a></td>
                <td [title]="getRoleTooltip(location?.role)">{{ getDisplayRole(location?.role) }}</td>
                <!-- <td><a
                  style="font-size: 12px;"
                  [routerLink]="'/reports/'+ location.id"
                >View Details</a></td> -->
              </tr>
          </table>
        </div>
    </mat-card-content>
  </mat-card>
</div>